import collins from "../assets/images/collins.jpeg";

const teamMembers = [
  {
    id: "john1",
    name: "John Doe",
    role: "Chief Executive Officer",
    image: collins,
    cardImage: collins,
    expertise: [],
    bio: ["I am john"],
  },
  {
    id: "john2",
    name: "John Doe",
    role: "Partner",
    image: collins,
    cardImage: collins,
    expertise: [],
    bio: ["I am john"],
  },
  {
    id: "john3",
    name: "John Doe",
    role: "Partner",
    image: collins,
    cardImage: collins,
    expertise: [],
    bio: ["I am john"],
  },
];

export default teamMembers;
